import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { AddOutlined, DeleteOutline } from "@material-ui/icons"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
import Checkbox from "../../components/Checkbox/Checkbox"
import Table from "../../components/Table/Table"
// Data
import { updateOrder } from "../../redux/apiCalls"
// Styles
import {
   Container,
   Wrapper,
   Main,
   WideBox,
   BoxTitle,
   StyledForm,
   FormItem,
   StyledLabel,
   StyledInput,
   StyledSelect,
   StyledOption,
   StyledTextArea,
} from "./Order.styles"
import {
   GeneralInfo,
   ProductDetail,
   Image,
   Details,
   ProductInfo,
} from "./Order.styles"
import {
   ButtonContainer,
   ButtonWrapper,
   StyledButton,
   Message,
   TitleWrapper,
   Title,
   Display,
   InfoItem,
   Column,
   Info,
   Addresses,
   StyledIcon,
} from "./Order.styles"

const Order = () => {
   const { orderId } = useParams()
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const [errorMessage, setErrorMessage] = useState("")
   const [orderInputs, setOrderInputs] = useState({})
   const [deliveryAddress, setDeliveryAddress] = useState({})
   const [invoiceAddress, setInvoiceAddress] = useState({})
   const [productLines, setProductLines] = useState([])
   const [newLine, setNewLine] = useState({})
   const order = useSelector((state) =>
      state.order.orders.find((order) => order._id.toString() === orderId)
   )
   const products = useSelector((state) => state.product.products)
   const user = useSelector((state) =>
      state.user.users.find((user) => user._id === order.userId)
   )

   useEffect(() => {
      if (typeof order === "object" && order !== null) {
         setOrderInputs({ ...order })
         setDeliveryAddress({ ...order.deliveryAddress })
         setInvoiceAddress({ ...order.invoiceAddress })

         let productsToUpdate = []
         for (let i = 0; i < order.products.length; i++) {
            productsToUpdate.push({ ...order.products[i] })
         }
         setProductLines(productsToUpdate)
      }
   }, [order])

   const [payed, setPayed] = useState(order.paymentTerms[0]?.payed)
   const payedChange = () => {
      setOrderInputs((prev) => {
         return {
            ...prev,
            paymentTerms: [
               {
                  ...prev.paymentTerms[0],
                  payed: !payed,
               },
            ],
         }
      })
      setPayed((current) => !current)
   }

   const handleChange = (e) => {
      if (e.target.name === "discount") {
         const total = calculateTotal(productLines, e.target.value)
         setOrderInputs((prev) => {
            return {
               ...prev,
               discount: e.target.value,
               amount: total.amountCalc,
            }
         })
      } else {
         setOrderInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value }
         })
      }
   }

   const handleDeliveryChange = (e) => {
      setDeliveryAddress((prev) => {
         return { ...prev, [e.target.name]: e.target.value }
      })
   }

   const handleInvoiceChange = (e) => {
      setInvoiceAddress((prev) => {
         return { ...prev, [e.target.name]: e.target.value }
      })
   }

   const handleProductChange = (e) => {
      let productValues = productLines
      productValues[parseInt(e.target.name.split("_")[0])][
         e.target.name.split("_")[1]
      ] = e.target.value
      setProductLines([...productValues])

      const total = calculateTotal(productValues, orderInputs.discount)
      setOrderInputs((prev) => {
         return {
            ...prev,
            totalQuantity: total.qtyCalc,
            amount: total.amountCalc,
         }
      })
   }

   const handleDelete = (index) => {
      const total = calculateTotal(
         [...productLines.slice(0, index), ...productLines.slice(index + 1)],
         orderInputs.discount
      )
      setProductLines((prev) => [
         ...prev.slice(0, index),
         ...prev.slice(index + 1),
      ])
      setOrderInputs((prev) => {
         return {
            ...prev,
            totalQuantity: total.qtyCalc,
            amount: total.amountCalc,
         }
      })
   }

   const handleNewLine = (e) => {
      const productWithVariation = products.find((product) => {
         const variation = product.variations.find(
            (item) => item._id === e.target.value
         )
         if (variation) {
            return true
         } else {
            return false
         }
      })

      if (productWithVariation) {
         const { variations, ...product } = productWithVariation
         const variation = productWithVariation.variations.find(
            (item) => item._id === e.target.value
         )
         const result = { ...product, ...variation }
         setNewLine({
            code: result.code,
            collectionSeason: result.collectionSeason,
            detailedColor: result.detailedColor,
            ean: result.ean,
            imageUrl: result.imagesDark[0],
            info: "",
            inventory: result.inventory,
            model: result.title,
            outOfCollection: result.outOfCollection,
            quantity: 1,
            size: result.lensWidth + " - " + result.nose,
            unitPrice: result.prices.find((item) => item.userType === user.type)
               .price,
         })
      }
   }

   const handleAddLine = () => {
      const total = calculateTotal(
         [...productLines, newLine],
         orderInputs.discount
      )
      setProductLines((prev) => {
         return [...prev, newLine]
      })
      setOrderInputs((prev) => {
         return {
            ...prev,
            totalQuantity: total.qtyCalc,
            amount: total.amountCalc,
         }
      })
   }

   const handleSubmit = async (e) => {
      e.preventDefault()
      const res = await updateOrder(
         orderInputs._id,
         {
            ...orderInputs,
            products: productLines,
            deliveryAddress,
            invoiceAddress,
         },
         dispatch
      )
      if (res === "success") {
         navigate("/orders")
      } else {
         setErrorMessage(JSON.stringify(res))
      }
   }

   const calculateTotal = (productValues, discount) => {
      let amountCalc = 0
      let qtyCalc = 0
      for (let i = 0; i < productValues.length; i++) {
         amountCalc +=
            parseFloat(productValues[i].quantity) *
            parseFloat(productValues[i].unitPrice)
         qtyCalc += parseFloat(productValues[i].quantity)
      }
      amountCalc =
         parseFloat(amountCalc) -
         (parseFloat(amountCalc) * parseFloat(discount)) / 100
      return { amountCalc, qtyCalc }
   }

   const linesHeader = [
      { name: "Product", size: 30, align: "left" },
      { name: "Quantity", size: 10, align: "left" },
      { name: "Unit Price", size: 15, align: "left" },
      { name: "Infos", size: 25, align: "left" },
      { name: "Action", size: 10, align: "left" },
   ]

   let linesData = []
   for (let i = 0; i < productLines.length; i++) {
      linesData.push([
         <ProductDetail>
            <Image src={productLines[i].imageUrl} />
            <Details>
               <ProductInfo>
                  <b>Model : </b>
                  {productLines[i].model}
               </ProductInfo>
               <ProductInfo>
                  <b>Code : </b>
                  {productLines[i].code}
               </ProductInfo>
               {productLines[i].detailedColor.length <= 2 ? (
                  <></>
               ) : (
                  <ProductInfo>
                     <b>Color : </b>
                     {productLines[i].detailedColor}
                  </ProductInfo>
               )}
               <ProductInfo>
                  <b>Size : </b>{" "}
                  {productLines[i].detailedColor.length <= 2
                     ? productLines[i].detailedColor
                     : productLines[i].size.replace(
                          "undefined - undefined",
                          "unique"
                       )}
               </ProductInfo>
            </Details>
         </ProductDetail>,
         <StyledInput
            type="number"
            name={`${i}_quantity`}
            placeholder={productLines[i].quantity}
            onChange={handleProductChange}
         />,
         <StyledInput
            type="number"
            name={`${i}_unitPrice`}
            placeholder={productLines[i].unitPrice}
            onChange={handleProductChange}
         />,
         <StyledInput
            type="text"
            name={`${i}_info`}
            placeholder={productLines[i].info}
            onChange={handleProductChange}
         />,
         <StyledIcon>
            <DeleteOutline onClick={() => handleDelete(i)} color="secondary" />
         </StyledIcon>,
      ])
   }

   linesData.push([
      <StyledInput
         type="text"
         placeholder="variationId"
         onChange={handleNewLine}
      />,
      <StyledInput type="text" value="1" readOnly />,
      "",
      "",
      <StyledIcon>
         <AddOutlined
            fontSize="large"
            onClick={handleAddLine}
            color="secondary"
         />
      </StyledIcon>,
   ])

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>Edit Order</Title>
               </TitleWrapper>
               <Display>
                  <Column>
                     <InfoItem>
                        <StyledLabel>Number :</StyledLabel>
                        <Info>{order.orderNumber}</Info>
                     </InfoItem>
                     <InfoItem>
                        <StyledLabel>ID :</StyledLabel>
                        <Info>{order._id}</Info>
                     </InfoItem>
                     <InfoItem>
                        <StyledLabel>Creation :</StyledLabel>
                        <Info>{order.createdAt}</Info>
                     </InfoItem>
                     <InfoItem>
                        <StyledLabel>Update :</StyledLabel>
                        <Info>{order.updatedAt}</Info>
                     </InfoItem>
                  </Column>
                  <Column>
                     <InfoItem>
                        <StyledLabel>Amount :</StyledLabel>
                        <Info>{orderInputs.amount}€</Info>
                     </InfoItem>
                     <InfoItem>
                        <StyledLabel>Total Quantity :</StyledLabel>
                        <Info>{orderInputs.totalQuantity}</Info>
                     </InfoItem>
                  </Column>
               </Display>
               <WideBox>
                  <BoxTitle>Edit</BoxTitle>
                  <StyledForm>
                     <GeneralInfo>
                        <FormItem>
                           <StyledLabel>Status</StyledLabel>
                           <StyledSelect
                              name="status"
                              id="status"
                              defaultValue={order.status}
                              onChange={handleChange}
                           >
                              <StyledOption value="pending">
                                 Pending
                              </StyledOption>
                              <StyledOption value="cancelled">
                                 Cancelled
                              </StyledOption>
                              <StyledOption value="sent">Sent</StyledOption>
                           </StyledSelect>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Payment</StyledLabel>
                           <StyledSelect
                              name="payment"
                              id="payment"
                              defaultValue={
                                 order.paymentTerms[0]?.paymentMethod
                              }
                              onChange={handleChange}
                           >
                              <StyledOption value="card">Card</StyledOption>
                              <StyledOption value="transfer">
                                 Transfer
                              </StyledOption>
                              <StyledOption value="debit">
                                 Direct Debit
                              </StyledOption>
                              <StyledOption value="check">Check</StyledOption>
                           </StyledSelect>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>
                              <Checkbox
                                 checked={order.paymentTerms[0]?.payed}
                                 onChange={payedChange}
                              />
                              Payed
                           </StyledLabel>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Discount</StyledLabel>
                           <StyledInput
                              type="number"
                              name="discount"
                              defaultValue={order.discount}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Comment (internal)</StyledLabel>
                           <StyledTextArea
                              name="commentInternal"
                              defaultValue={order.commentInternal}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Comment (for customer)</StyledLabel>
                           <StyledTextArea
                              name="commentForCustomer"
                              defaultValue={order.commentForCustomer}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Carrier URL</StyledLabel>
                           <StyledInput
                              type="text"
                              name="carrierUrl"
                              defaultValue={order.carrierUrl}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Shipping method</StyledLabel>
                           <StyledInput
                              type="text"
                              name="shippingMethod"
                              defaultValue={order.shippingMethod}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Shipping price</StyledLabel>
                           <StyledInput
                              type="number"
                              name="shippingPrice"
                              defaultValue={order.shippingPrice}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Customer</StyledLabel>
                           <StyledInput
                              type="text"
                              name="userId"
                              defaultValue={order.userId}
                              onChange={handleChange}
                           />
                        </FormItem>
                     </GeneralInfo>
                     <Addresses>
                        <Column>
                           <StyledLabel>Delivery Address</StyledLabel>
                           <StyledInput
                              type="text"
                              name="name"
                              defaultValue={deliveryAddress.name}
                              onChange={handleDeliveryChange}
                           />
                           <StyledInput
                              type="text"
                              name="street"
                              defaultValue={deliveryAddress.street}
                              onChange={handleDeliveryChange}
                           />
                           <StyledInput
                              type="text"
                              name="zipCode"
                              defaultValue={deliveryAddress.zipCode}
                              onChange={handleDeliveryChange}
                           />
                           <StyledInput
                              type="text"
                              name="city"
                              defaultValue={deliveryAddress.city}
                              onChange={handleDeliveryChange}
                           />
                           <StyledInput
                              type="text"
                              name="country"
                              defaultValue={deliveryAddress.country}
                              onChange={handleDeliveryChange}
                           />
                           <StyledLabel>Infos</StyledLabel>
                           <StyledTextArea
                              name="info"
                              defaultValue={deliveryAddress.info}
                              onChange={handleDeliveryChange}
                           />
                        </Column>
                        <Column>
                           <StyledLabel>Invoice Address</StyledLabel>
                           <StyledInput
                              type="text"
                              name="name"
                              defaultValue={invoiceAddress.name}
                              onChange={handleInvoiceChange}
                           />
                           <StyledInput
                              type="text"
                              name="street"
                              defaultValue={invoiceAddress.street}
                              onChange={handleInvoiceChange}
                           />
                           <StyledInput
                              type="text"
                              name="zipCode"
                              defaultValue={invoiceAddress.zipCode}
                              onChange={handleInvoiceChange}
                           />
                           <StyledInput
                              type="text"
                              name="city"
                              defaultValue={invoiceAddress.city}
                              onChange={handleInvoiceChange}
                           />
                           <StyledInput
                              type="text"
                              name="country"
                              defaultValue={invoiceAddress.country}
                              onChange={handleInvoiceChange}
                           />
                           <StyledLabel>Infos</StyledLabel>
                           <StyledTextArea
                              name="info"
                              defaultValue={invoiceAddress.info}
                              onChange={handleInvoiceChange}
                           />
                        </Column>
                     </Addresses>
                  </StyledForm>
               </WideBox>
               <WideBox>
                  <BoxTitle>Lines</BoxTitle>
                  <Table data={linesData} headers={linesHeader} pageSize={20} />
               </WideBox>
               <ButtonContainer>
                  <ButtonWrapper>
                     <StyledButton onClick={handleSubmit}>Update</StyledButton>
                     <Message>{errorMessage}</Message>
                  </ButtonWrapper>
               </ButtonContainer>
            </Main>
         </Container>
      </>
   )
}

export default Order
